<template>
  <div class="tl:px-8 ph:px-6 mx-auto max-w-[90rem] px-12">
    <slot />
  </div>
</template>
